import { create } from 'zustand';
import { SearchParams, Booking, SelectedBooking, PassengerInfo } from '../models/Booking';

/**
 * Store global para el flujo de reserva
 * Similar a un Service en Angular
 */
interface BookingStore {
  // Estado
  searchParams: SearchParams;
  selectedBooking: SelectedBooking | null;
  passengerData: PassengerInfo[];
  
  // Actions
  setSearchParams: (params: SearchParams) => void;
  setSelectedBooking: (booking: Booking, seats: string[]) => void;
  setPassengerData: (passengers: PassengerInfo[]) => void;
  clearBooking: () => void;
}

const initialSearchParams: SearchParams = {
  origen: '',
  destino: '',
  fecha: '',
  pasajeros: '1',
};

export const useBookingStore = create<BookingStore>((set) => ({
  // Estado inicial
  searchParams: initialSearchParams,
  selectedBooking: null,
  passengerData: [],

  // Acciones
  setSearchParams: (params) => set({ searchParams: params }),
  
  setSelectedBooking: (booking, seats) => set({
    selectedBooking: {
      ...booking,
      selectedSeats: seats,
    },
  }),
  
  setPassengerData: (passengers) => set({ passengerData: passengers }),
  
  clearBooking: () => set({
    searchParams: initialSearchParams,
    selectedBooking: null,
    passengerData: [],
  }),
}));
